import api from '../api'

export const postCulture = (params) => api.post('/admin/cultures', params)

export const putCulture = ({ id, ...params }) => api.put(`/admin/cultures/${ id }`, params)

export const deleteCulture = ({ id }) => api.delete(`/admin/cultures/${ id }`)
